import React from 'react';
import PropTypes from 'prop-types';

import Grid from '@mui/material/Grid';
import { Box, Paper } from '@mui/material';

import { Details } from './components';

const PTInfo = ({ className }) => {
  return (
    <Box
      className={className}
      sx={{
        width: '100%',
        height: '100%',
        minHeight: 0,
        overflow: 'hidden'
      }}>
      <Paper
        elevation={0}
        sx={{
          backgroundColor: '#fff',
          border: '1px solid #DCDCDC',
          borderRadius: '10px',
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.10)',
          boxSizing: 'border-box',
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          minHeight: 0,
          overflow: 'hidden',
          p: 1.5
        }}>
        <Box
          sx={{
            display: 'flex',
            flex: 1,
            minHeight: 0,
            overflow: 'hidden',
            width: '100%'
          }}>
          <Details />
        </Box>
      </Paper>
    </Box>
  );
};

PTInfo.propTypes = {
  className: PropTypes.string
};

export default PTInfo;